import { FC } from "react";

import { LogoBrandDark } from "../../assets"
import { MannkindLogo } from "../../assets"
import { FooterTextProps } from "./types";



const FooterText: FC<FooterTextProps> = (): JSX.Element => {
  return (
      <div className="row mt-4 mt-md-5 pb-3" style={{maxWidth:'800px', minWidth:'800px', margin:'auto'}}>
        <div className="col-md-5 d-flex flex-column gap-3">
            <img className={"pb-2 p-lg-0"} width="250px" alt="Furoscix" src={LogoBrandDark}/>
            <img className={"pb-2 p-lg-0"} width="250px" alt="Furoscix" src={MannkindLogo}/>
        </div>
        <div className="col-md-6">
          <small className="d-flex flex-column">
              Copyright (c) 2026. MannKind Corporation.
              <br/>
              US-FUR-0222 07/2026
              <br/>
              This site is intended for US Healthcare Professionals only.
              <br/>
          </small>
        </div>
      </div>
  );
};

export default FooterText;
